import { Text } from '@joor/design-system'
import styled from 'styled-components'

export const CustomTooltip = styled.div`
  padding: 12px;
  background-color: white;
  border-radius: 5px;
  box-shadow: var(--elevation-4);
`

interface HeaderTooltipProps {
  value: string
}

export const HeaderTooltip = ({ value }: HeaderTooltipProps) => (
  <CustomTooltip>
    <Text
      fontSize="small"
      fontWeight="medium"
      color="primary-900"
      letterSpacing="tighter"
    >
      {value}
    </Text>
  </CustomTooltip>
)
